import { ReactNode } from "react";

export interface BillsPaymentHistoryData {
  date: string;
  amount: string;
  transactionreference: string,
  billerCode: string,
  merchantRef:string
  packageCode:string,
  fee:string,
  status:ReactNode
  action: React.ReactNode;
}

export const ColumnBillsPayment = [
  {
    Header: "Date Initiated",
    accessor: "date",
  },
  {
    Header: "Amount",
    accessor: "amount",
  },
  {
    Header: "Fee",
    accessor: "fee",
  },
  {
    Header: "Transaction Reference",
    accessor: "transactionreference",
  },
  {
    Header: "Merchant Reference",
    accessor: "merchantRef"
  },

  {
    Header: "Bill Provider",
    accessor: "billerCode",
  },
  {
    Header: "Product",
    accessor: "packageCode",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Action",
    accessor: "action",
  },
];